<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
          <div class="text-center mt-5 mb-5">
            <h5>Abschlussdokumentation zum Fallmanagement nach psychosomatischer Rehabilitationg</h5>
          </div>

          <div class="row mt-5">
            <div class="col-lg-8 col-md-12 col-sm-12">
              <h5 class="mb-3">Dauer des durchgeführten Fallmanagements</h5>

              <div class="row mb-1">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  Beginn des Fallmanagements
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <Datepicker
                      class="mb-1"
                      v-model="formData.dateOfCaseManagementBeginning"
                      :required="true"
                      position="down"/>
                </div>
              </div>
              <div class="row mb-1 mt-3 mt-sm-0">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  Datum des Erstgesprächs während der Rehabilitation
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <Datepicker
                      class="mb-1"
                      v-model="formData.dateOfTheFirstConsultationDuringRehabilitation"
                      :required="true"
                      position="down"/>
                </div>
              </div>
              <div class="row mb-1 mt-3 mt-sm-0">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  Datum des ersten Gesprächs nach der Rehabilitation
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <Datepicker
                      class="mb-1"
                      v-model="formData.dateOfTheFirstInterviewAfterRehabilitation"
                      :required="true"
                      position="down"/>
                </div>
              </div>
              <div class="row mb-1 mt-3 mt-sm-0">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  Datum des letzten Gesprächs
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <Datepicker
                      class="mb-1"
                      v-model="formData.dateOfLastConversation"
                      :required="true"
                      position="down"/>
                </div>
              </div>

              <div class="row mb-2 mt-3 mt-sm-0">
                <div class="col-3" style="margin-top: -5px;">Verlängerung</div>
                <div class="col-8">
                  <BaseCheckbox v-model="formData.renewal"/>
                </div>
              </div>

              <div class="row">
                <div class="col-3" style="margin-top: -5px;">Abbruch</div>
                <div class="col-1">
                  <BaseCheckbox v-model="formData.cancellation"/>
                </div>
                <div class="col-lg-8 col-md-10 col-sm-12 mt-3 mt-sm-0">
                  <BaseInput
                      v-model="formData.ground"
                      placeholder="Grund"/>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <h6 class="mb-0">Mit der Versicherten / dem Versicherten vereinbarte Ziele des Fallmanagements</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-12" v-for="(objective, index) in formData.objectives" :key="index">
              <div class="row mt-4 align-items-center">
                <BaseInput
                    v-model="objective.id"
                    hidden="hidden"/>

                <div class="col">
                  <BaseInput
                      v-model="objective.objective"/>
                </div>

                <div class="col-auto">
                  <BaseCheckbox
                      v-model="objective.achieved"
                      label="erreicht"
                      :labelPosition="'right'"/>
                </div>

                <div class="col-auto">
                  <button class="btn btn-danger"
                          @click.prevent="deleteObjective(index)">
                    <i class="os-icon os-icon-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-12 text-end">
              <button type="button" class="btn btn-primary" @click="addObjective">+</button>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <h5>Angaben der Versicherten / des Versicherten zur Erwerbstätigkeit und Arbeitsfähigkeit</h5>
              <div class="row mt-3">
                <div class="col-12 mb-3" style="font-size: 18px;">Erwerbstätigkeit</div>
                <div class="col-12" style="font-size: 16px; font-weight: 600"> zu Beginn des Fallmanagements</div>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-1">
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.employedAtTheBeginningOfCaseManagement"
                  label="berufstätig"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.unemployedAtTheBeginningOfCaseManagement"
                  label="arbeitslos"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.housekeepingAtTheBeginningOfCaseManagement"
                  label="Hausfrauen/Hausmanntätigkeit"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.notEmployedAtTheBeginningOfCaseManagement"
                  label="nicht erwerbstätig (nicht ankreuzen, wenn 2. oder 3. dieser Spalte zutrifft"
                  :labelPosition="'right'"/>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.othersAtTheBeginningOfCaseManagement"
                  label="Sonstiges"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-8 col-md-12">
              <BaseInput v-model="formData.othersDescriptionAtTheBeginningOfCaseManagement"/>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4">
              <BaseInput v-model="formData.timeFrameAtTheBeginningOfCaseManagement"
                         label="zeitlicher Umfang"/>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4">
              <BaseInput v-model="formData.hoursPerWeekAtTheBeginningOfCaseManagement"
                         label="Stunden pro Woche"/>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-10 col-lg-11 col-md-12 col-sm-12">
              <TextEditor
                  v-model="formData.miscellaneousDescriptionAtTheBeginningOfCaseManagement"
                  @update:model-value="formData.miscellaneousDescriptionAtTheBeginningOfCaseManagement = $event"
                  :inputStyle="{ height: '200px' }"/>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12" style="font-size: 16px; font-weight: 600">
              zum Ende des Fallmanagements
            </div>
          </div>
          <div class="row mt-3 mb-1">
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.employedAtTheEndOfCaseManagement"
                  label="berufstätig"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.unemployedAtTheEndOfCaseManagement"
                  label="arbeitslos"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.housekeepingAtTheEndOfCaseManagement"
                  label="Hausfrauen/Hausmanntätigkeit"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.notEmployedAtTheEndOfCaseManagement"
                  label="nicht erwerbstätig (nicht ankreuzen, wenn 2. oder 3. dieser Spalte zutrifft"
                  :labelPosition="'right'"/>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.othersAtTheEndOfCaseManagement"
                  label="Sonstiges"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-8 col-md-12">
              <BaseInput v-model="formData.othersDescriptionAtTheEndOfCaseManagement"/>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4">
              <BaseInput v-model="formData.timeFrameAtTheEndOfCaseManagement"
                         label="zeitlicher Umfang"/>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4">
              <BaseInput v-model="formData.hoursPerWeekAtTheEndOfCaseManagement"
                         label="Stunden pro Woche"/>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <div class="row mb-1">
                <div class="col-12" style="font-size: 16px; font-weight: 600"> Aktueller Arbeitsplatz</div>
              </div>
              <div class="row mb-1">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.onTheOldStayedAtWork"
                      label="im alten Betrieb, am alten Arbeitsplatz geblieben"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.atAnotherWorkplace"
                      label="im alten Betrieb, an einem anderen Arbeitsplatz"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.inANewCompany"
                      label="In einem neuen Betrieb"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.selfEmployed"
                      label="selbstständig"
                      :labelPosition="'right'"/>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.miniJob"
                      label="Minijob"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.internship"
                      label="Praktikum oder Vergleichbares"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.limited"
                      label="zeitlich begrenzt"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.solidEmployment"
                      label="feste Anstellung"
                      :labelPosition="'right'"/>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-lg-2 col-md-3 col-sm-12">
                  <BaseCheckbox
                      v-model="formData.miscellaneous"
                      label="Sonstiges"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-lg-8 col-md-9 col-sm-12">
                  <BaseInput v-model="formData.miscellaneousDescription"/>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <div class="row">
                <h5 class="col-12">Arbeitsfähigkei</h5>
              </div>
              <div class="row mt-1">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.unableToWorkMainDisease"
                      label="arbeitsunfähig wegen der für die Rehabilitation zugrunde liegenden Haupterkrankung (wichtigstes Leiden)"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.unableToWorkAnotherIllness"
                      label="arbeitsunfähig wegen einer anderen Erkrankung"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.ableToWork"
                      label="arbeitsfähig"
                      :labelPosition="'right'"/>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
                  <BaseCheckbox
                      v-model="formData.notSpecified"
                      label="keine Angabe"
                      :labelPosition="'right'"/>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12">
                  <TextEditor
                      v-model="formData.remarks"
                      @update:model-value="formData.remarks = $event"
                      :inputStyle="{ height: '200px' }"/>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <div class="row">
                <h5 class="col-12">Vereinbarte Maßnahmen</h5>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="font-size: 16px; font-weight: 600"> Therapeutische Maßnahmen</div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.psychotherapy"
                  label="Psychotherapie"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.familyTalks"
                  label="Paargespräche / Familiengespräche"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.addictionCounseling"
                  label="Suchtberatung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.furtherMedicalTreatment"
                  label="medizinische Weiterbehandlung oder Mitbehandlung"
                  :labelPosition="'right'"/>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12" style="font-size: 16px; font-weight: 600">Maßnahmen zur Teilhabe am Arbeitsleben</div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.gradualReintegration"
                  label="stufenweise Wiedereingliederung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.changedWorkplaceDesign"
                  label="veränderte Arbeitsplatzgestaltung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-sm-12 mb-1">
              <BaseCheckbox
                  v-model="formData.lta"
                  label="LTA"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-xl-4 col-lg-11 col-md-12 col-sm-12">
              <BaseInput v-model="formData.which" label="Welche?"/>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12" style="font-size: 16px; font-weight: 600">Sonstige Maßnahmen</div>
            <div class="col-12 col-sm-6 col-md-2 mt-2">
              <BaseCheckbox
                  v-model="formData.otherSuggestion"
                  label="sonstige Anregung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-12 col-sm-6 col-md-2 mt-2">
              <BaseCheckbox
                  v-model="formData.supportGroup"
                  label="Selbsthilfegruppe"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <BaseInput v-model="formData.supportGroupDescription"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <TextEditor
                  v-model="formData.explanations"
                  @update:model-value="formData.explanations = $event"
                  label="Erläuterungen"
                  :inputStyle="{ height: '200px' }"/>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12">
              <h5>Verlauf des Fallmanagements / erreichte Ziele:</h5>
            </div>
            <div class="col-12">
              <TextEditor
                  v-model="formData.goalsAchieved"
                  @update:model-value="formData.goalsAchieved = $event"
                  :inputStyle="{ height: '200px' }"/>
            </div>
          </div>

          <div class="d-flex justify-content-center w-100 mt-4">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalCaseManagementCoachingService from '@/api/Portal/CaseManagementCoaching';
import caseManagementCoachingCoachingService from '@/api/Unemployed/CaseManagementCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/CaseManagementCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/CaseManagementCoaching/Menu.vue';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const {t} = useI18n();
const route = useRoute();
const coachingData = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const coachingId = +route.params.id;
const clientId = ref(null)

const formData = ref({
  coachingId: '',

  // Duration of case management carried out
  dateOfCaseManagementBeginning: '',
  dateOfTheFirstConsultationDuringRehabilitation: '',
  dateOfTheFirstInterviewAfterRehabilitation: '',
  dateOfLastConversation: '',
  renewal: false,
  cancellation: false,
  ground: '',

  // Case management objectives agreed with the insured
  objectives: [
    {objective: '', achieved: false},
    {objective: '', achieved: false},
    {objective: '', achieved: false},
    {objective: '', achieved: false},
  ],

  //Information provided by the insured on employment and the ability to work
  employedAtTheBeginningOfCaseManagement: false,
  unemployedAtTheBeginningOfCaseManagement: false,
  housekeepingAtTheBeginningOfCaseManagement: false,
  notEmployedAtTheBeginningOfCaseManagement: false,
  othersAtTheBeginningOfCaseManagement: false,
  othersDescriptionAtTheBeginningOfCaseManagement: '',
  timeFrameAtTheBeginningOfCaseManagement: '',
  hoursPerWeekAtTheBeginningOfCaseManagement: '',
  miscellaneousDescriptionAtTheBeginningOfCaseManagement: '',

  // at the end of case management (subsection)
  employedAtTheEndOfCaseManagement: false,
  unemployedAtTheEndOfCaseManagement: false,
  housekeepingAtTheEndOfCaseManagement: false,
  notEmployedAtTheEndOfCaseManagement: false,
  othersAtTheEndOfCaseManagement: false,
  othersDescriptionAtTheEndOfCaseManagement: '',
  timeFrameAtTheEndOfCaseManagement: '',
  hoursPerWeekAtTheEndOfCaseManagement: '',

  // subsection
  onTheOldStayedAtWork: false,
  atAnotherWorkplace: false,
  inANewCompany: false,
  selfEmployed: false,
  miniJob: false,
  internship: false,
  miscellaneous: false,
  miscellaneousDescription: '',
  limited: false,
  solidEmployment: false,

  // ability to work (subsection)
  unableToWorkMainDisease: false,
  unableToWorkAnotherIllness: false,
  ableToWork: false,
  notSpecified: false,
  remarks: '',

  //  Agreed Actions
  psychotherapy: false,
  familyTalks: false,
  addictionCounseling: false,
  furtherMedicalTreatment: false,
  gradualReintegration: false,
  changedWorkplaceDesign: false,
  lta: false,
  which: '',
  otherSuggestion: false,
  supportGroup: false,
  supportGroupDescription: '',
  explanations: '',

  // goals achieved
  goalsAchieved: '',
});

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalCaseManagementCoachingService.submitFinalReport(formData.value);

    await getFinalInterviewData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const {data} = await caseManagementCoachingCoachingService.getCaseManagementCoaching(+coachingId);

    coachingData.value = data.data;
    clientId.value = data.data.client.id
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getFinalInterviewData() {
  try {
    const {data} = await portalCaseManagementCoachingService.getFinalReport(+coachingId);
    const objectivesArray = data.data?.objectives || [];
    const objectives = objectivesArray.map(item => ({
      id: item.id,
      objective: item.objective,
      achieved: item.achieved,
    }));

    if (data.data) {
      formData.value = {...data.data, objectives: objectives};
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

async function addObjective() {
  formData.value.objectives.push({id: '', objective: '', achieved: false});
}

async function deleteObjective(index) {
  formData.value.objectives.splice(index, 1);
}

onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getFinalInterviewData(),
  ]);

  isLoaded.value = true;
});
</script>
<style scoped>

</style>